import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue'
import { ResultadoBusca } from '../../../../common/types/Busca'
import ItemIrmao from './ItemIrmao.vue'
import ItemPotencia from '@/components/ItemPotencia.vue'
import ItemLoja from '@/components/ItemLoja.vue'
import ItemEsposa from './ItemEsposa.vue'
import ItemServico from './ItemServico.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemDaBusca',
  props: {
	item: { type: Object as PropType<ResultadoBusca>, required: true },
},
  setup(__props) {

const props = __props;



const componente = computed(() => {
	switch (props.item.resultType) {
		case 'irmao': return ItemIrmao
		case 'loja': return ItemLoja
		case 'potencia': return ItemPotencia
		case 'esposa': return ItemEsposa
		case 'servico': return ItemServico
		default: return 'div'
	}
})

return { __sfc: true,props, componente }
}

})